export default "__VITE_ASSET__BYNpS86x__"